import React, { useEffect, useState, useCallback } from "react";
import { AnimatePresence, motion } from "framer-motion";

const TestimonialCarousel = ({ items, autoplayMs = 6000 }) => {
  const [index, setIndex] = useState(0);
  const count = items.length;

  const go = useCallback(
    (next) => setIndex((i) => (next + count) % count),
    [count]
  );

  useEffect(() => {
    if (!autoplayMs) return;
    const id = setInterval(() => go(index + 1), autoplayMs);
    return () => clearInterval(id);
  }, [index, autoplayMs, go]);

  const current = items[index];

  return (
    <div className="testimonial-carousel">
      <div className="testimonial-carousel__viewport">
        <AnimatePresence mode="wait">
          <motion.blockquote
            key={index}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -16 }}
            transition={{ duration: 0.4 }}
            className="testimonial-card"
          >
            <p className="testimonial-quote">“{current.quote}”</p>
            <footer className="testimonial-attribution">
              <strong>{current.name}</strong>
              <span>{current.role}</span>
            </footer>
          </motion.blockquote>
        </AnimatePresence>
      </div>

      <div className="testimonial-carousel__controls">
        <button
          type="button"
          aria-label="Previous testimonial"
          onClick={() => go(index - 1)}
          className="testimonial-arrow"
        >
          ‹
        </button>
        <div className="testimonial-dots">
          {items.map((_, i) => (
            <button
              key={i}
              type="button"
              aria-label={`Go to testimonial ${i + 1}`}
              className={"testimonial-dot" + (i === index ? " is-active" : "")}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>
        <button
          type="button"
          aria-label="Next testimonial"
          onClick={() => go(index + 1)}
          className="testimonial-arrow"
        >
          ›
        </button>
      </div>
    </div>
  );
};

export default TestimonialCarousel;
